module.exports = __webpack_public_path__ + "img/bold.9ce6cb2b.svg";